import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TbsButtonModule } from '@ngx-terabase/ui/button';
import { TbsTitleModule } from '@ngx-terabase/ui/title';
import { MissionUploadResult } from '../upload-mission/upload-mission.component';
import { map, of } from 'rxjs';
import { MissionCreationResult } from '../new-mission/new-mission.component';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserContextService } from 'src/app/services/user-context.service';

@Component({
  selector: 'app-mission-result',
  imports: [CommonModule, TbsTitleModule, TbsButtonModule],
  templateUrl: './mission-result.component.html',
  styleUrl: './mission-result.component.scss',
  standalone: true,
})
export class MissionResultComponent implements OnInit {
  @Input() public missionCreationResult!: MissionCreationResult;
  @Input() public missionUploadResult!: MissionUploadResult;
  @Output() public newMission = new EventEmitter();

  public date: string = '';

  private http = inject(HttpClient);
  private userContext = inject(UserContextService);

  public user$ = of(this.userContext.user).pipe(
    map((response) => {
      const contactProfile = response.contact_profile;
      return `${contactProfile.first_name} ${contactProfile.last_name}`;
    })
  );

  ngOnInit(): void {
    this.date = this.missionCreationResult.date.format('MMM D, yyyy h:mm A');
  }
}
